import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

export default function AdminGuard({ children }: { children: ReactNode }) {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  if (!user || profile?.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full rounded-2xl border p-10 text-center"
          style={{ background: 'oklch(0.16 0.03 280)', borderColor: 'oklch(0.28 0.05 280)' }}
        >
          <ShieldAlert className="w-16 h-16 text-destructive mx-auto mb-5" />
          <h2
            className="text-2xl font-black text-foreground mb-3"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            BRAK DOSTĘPU
          </h2>
          <p className="text-muted-foreground mb-6" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            {!user
              ? 'Musisz być zalogowany, aby wejść do panelu admina.'
              : 'Twoje konto nie ma uprawnień administratora.'}
          </p>
          <Button
            onClick={() => (window.location.hash = '/')}
            className="bg-primary hover:bg-primary/90"
          >
            Wróć na stronę główną
          </Button>
        </motion.div>
      </div>
    );
  }

  return <>{children}</>;
}
